import React, { useRef, Suspense } from "react";
import { useFrame } from "@react-three/fiber";
import { useGLTF } from "@react-three/drei";

function CowboyModel() {
  const meshRef = useRef();
  // Use process.env.PUBLIC_URL to ensure correct path resolution
  const modelPath = `${process.env.PUBLIC_URL}/model/cowboy.gltf`;
  const { scene } = useGLTF(modelPath);

  useFrame(() => {
    if (meshRef.current) {
      meshRef.current.rotation.y += 0.01;
    }
  });

  return (
    <Suspense fallback={null}>
      <primitive
        object={scene}
        ref={meshRef}
        scale={[16, 16, 16]}
        position={[0, 0, 0]}
      />
    </Suspense>
  );
}

// Preload with the same absolute path
useGLTF.preload(`${process.env.PUBLIC_URL}/model/cowboy.gltf`);

export default CowboyModel;
